/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
"use strict";

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.async-iterator.js");

require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.flat-map.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.array.unscopables.flat.js");

require("core-js/modules/es.array.unscopables.flat-map.js");

require("core-js/modules/es.math.acosh.js");

require("core-js/modules/es.math.hypot.js");

require("core-js/modules/es.object.define-getter.js");

require("core-js/modules/es.object.define-setter.js");

require("core-js/modules/es.object.entries.js");

require("core-js/modules/es.object.from-entries.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.lookup-getter.js");

require("core-js/modules/es.object.lookup-setter.js");

require("core-js/modules/es.object.values.js");

require("core-js/modules/es.promise.js");

require("core-js/modules/es.promise.finally.js");

require("core-js/modules/es.string.pad-end.js");

require("core-js/modules/es.string.pad-start.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.string.trim.js");

require("core-js/modules/es.string.trim-end.js");

require("core-js/modules/es.string.trim-start.js");

require("core-js/modules/es.typed-array.float32-array.js");

require("core-js/modules/es.typed-array.float64-array.js");

require("core-js/modules/es.typed-array.int8-array.js");

require("core-js/modules/es.typed-array.int16-array.js");

require("core-js/modules/es.typed-array.int32-array.js");

require("core-js/modules/es.typed-array.uint8-array.js");

require("core-js/modules/es.typed-array.uint8-clamped-array.js");

require("core-js/modules/es.typed-array.uint16-array.js");

require("core-js/modules/es.typed-array.uint32-array.js");

require("core-js/modules/es.typed-array.from.js");

require("core-js/modules/es.typed-array.of.js");

require("core-js/modules/web.queue-microtask.js");

require("core-js/modules/web.url.js");

require("core-js/modules/web.url.to-json.js");

require("core-js/modules/web.url-search-params.js");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _awaitAsyncGenerator(value) { return new _AwaitValue(value); }

function _wrapAsyncGenerator(fn) { return function () { return new _AsyncGenerator(fn.apply(this, arguments)); }; }

function _AsyncGenerator(gen) { var front, back; function send(key, arg) { return new Promise(function (resolve, reject) { var request = { key: key, arg: arg, resolve: resolve, reject: reject, next: null }; if (back) { back = back.next = request; } else { front = back = request; resume(key, arg); } }); } function resume(key, arg) { try { var result = gen[key](arg); var value = result.value; var wrappedAwait = value instanceof _AwaitValue; Promise.resolve(wrappedAwait ? value.wrapped : value).then(function (arg) { if (wrappedAwait) { resume(key === "return" ? "return" : "next", arg); return; } settle(result.done ? "return" : "normal", arg); }, function (err) { resume("throw", err); }); } catch (err) { settle("throw", err); } } function settle(type, value) { switch (type) { case "return": front.resolve({ value: value, done: true }); break; case "throw": front.reject(value); break; default: front.resolve({ value: value, done: false }); break; } front = front.next; if (front) { resume(front.key, front.arg); } else { back = null; } } this._invoke = send; if (typeof gen.return !== "function") { this.return = undefined; } }

_AsyncGenerator.prototype[typeof Symbol === "function" && Symbol.asyncIterator || "@@asyncIterator"] = function () { return this; };

_AsyncGenerator.prototype.next = function (arg) { return this._invoke("next", arg); };

_AsyncGenerator.prototype.throw = function (arg) { return this._invoke("throw", arg); };

_AsyncGenerator.prototype.return = function (arg) { return this._invoke("return", arg); };

function _AwaitValue(value) { this.wrapped = value; }

function _asyncIterator(iterable) { var method; if (typeof Symbol !== "undefined") { if (Symbol.asyncIterator) method = iterable[Symbol.asyncIterator]; if (method == null && Symbol.iterator) method = iterable[Symbol.iterator]; } if (method == null) method = iterable["@@asyncIterator"]; if (method == null) method = iterable["@@iterator"]; if (method == null) throw new TypeError("Object is not async iterable"); return method.call(iterable); }

const {
  AssetMetadata
} = require("../asset/assetmetadata");

const {
  AssetMultipart
} = require("../asset/assetmultipart");

const {
  AsyncGeneratorFunction
} = require("../generator/function");

const {
  postForm
} = require("../fetch");

const {
  retry
} = require("../retry");

const logger = require("../logger");

const {
  TransferEvents
} = require("../controller/transfercontroller");

const {
  MIMETYPE
} = require("../constants");
/**
 * @typedef {Object} AEMInitiateUploadOptions
 * @property {Number} [timeout=30000] Socket timeout
 * @property {Number} [retryMaxCount] number of retry attempts, overrides retryMaxDuration
 * @property {Number} [retryMaxDuration=60000] time to retry until throwing an error (ms)
 * @property {Number} [retryInterval=100] time between retries, used by exponential backoff (ms)
 * @property {Boolean} [retryEnabled=true] retry on failure enabled
 * @property {Boolean} [retryAllErrors=false] whether or not to retry on all http error codes or just >=500
 */

/**
 * Initiate upload of assets in AEM.
 */


class AEMInitiateUpload extends AsyncGeneratorFunction {
  /**
   * Construct the AEMInitiateUpload function.
   * 
   * @param {AEMInitiateUploadOptions} [options] Options to initiate upload
   */
  constructor(options) {
    super();
    this.options = options;
  }
  /**
   * Check if the given asset can be added to the batch of assets
   * 
   * @param {TransferAsset[]} batch Current batch of transfer assets (may be empty)
   * @param {TransferAsset} transferAsset Transfer asset to check
   * @returns {Boolean} True if the asset can be added to
   */


  checkAddBatch(batch, transferAsset) {
    const batchTarget = batch[0].target;
    const target = transferAsset.target;
    return batchTarget.folderUrl.toString() === target.folderUrl.toString();
  }
  /**
   * Initiates the upload of the given assets
   * 
   * notifyBefore: For each transfer asset added to the batch
   * notifyAfter: For each transfer asset after the initiate upload
   * notifyYield: For each transfer asset after it is yielded
   * 
   * @generator
   * @param {TransferAsset[]|Generator||AsyncGenerator} assets Transfer assets, target going to AEM
   * @param {TransferController} controller Transfer controller
   * @yields {TransferAsset} Transfer asset
   */


  execute(transferAssets, controller) {
    var _this = this;

    return _wrapAsyncGenerator(function* () {
      const assets = [];
      const form = new URLSearchParams();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;

      var _iteratorError;

      try {
        for (var _iterator = _asyncIterator(transferAssets), _step, _value; _step = yield _awaitAsyncGenerator(_iterator.next()), _iteratorNormalCompletion = _step.done, _value = yield _awaitAsyncGenerator(_step.value), !_iteratorNormalCompletion; _iteratorNormalCompletion = true) {
          const transferAsset = _value;
          controller.notify(TransferEvents.AEM_INITIATE_UPLOAD, _this.name, transferAsset);
          assets.push(transferAsset);
          form.append("fileName", transferAsset.target.filename);
          form.append("fileSize", transferAsset.metadata.contentLength);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            yield _awaitAsyncGenerator(_iterator.return());
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (assets.length === 0) {
        logger.warn("AEMInitiateUpload.execute on empty set of transfer assets");
        return;
      }

      try {
        const folderUrl = assets[0].target.folderUrl;
        const initiateResponse = yield _awaitAsyncGenerator(retry( /*#__PURE__*/_asyncToGenerator(function* () {
          return postForm(`${folderUrl}.initiateUpload.json`, form, {
            timeout: _this.options && _this.options.timeout,
            headers: assets[0].target.headers
          });
        }), _this.options));

        if (!Array.isArray(initiateResponse.files)) {
          throw Error(`'files' field missing in initiateUpload response: ${JSON.stringify(initiateResponse)}`);
        } else if (!Array.isArray(initiateResponse.files) || initiateResponse.files.length !== assets.length) {
          throw Error(`'files' field incomplete in initiateUpload response (expected files: ${assets.length}): ${JSON.stringify(initiateResponse)}`);
        } else if (typeof initiateResponse.completeURI !== "string") {
          throw Error(`'completeURI' field invalid in initiateUpload response: ${JSON.stringify(initiateResponse)}`);
        } // yield one or more smaller transfer parts if the source accepts ranges and the content length is large enough


        const files = initiateResponse.files;
        const completeUrl = new URL(initiateResponse.completeURI, folderUrl);

        for (let i = 0; i < assets.length; ++i) {
          const transferAsset = assets[i];
          const {
            minPartSize,
            maxPartSize,
            uploadURIs,
            mimeType,
            uploadToken
          } = files[i]; // validate response from the server

          if (!Number.isFinite(minPartSize) || !Number.isFinite(maxPartSize) || !Array.isArray(uploadURIs) || uploadURIs.length === 0) {
            throw Error(`invalid multi-part information for ${transferAsset.target.url}: ${JSON.stringify(files[i])}`);
          }

          if (minPartSize < 1) {
            throw Error(`invalid minPartSize for ${transferAsset.target.url}: ${JSON.stringify(files[i])}`);
          }

          if (maxPartSize < minPartSize) {
            throw Error(`invalid maxPartSize for ${transferAsset.target.url}: ${JSON.stringify(files[i])}`);
          }

          if (uploadURIs.findIndex(value => typeof value !== "string") !== -1) {
            throw Error(`invalid upload url for ${transferAsset.target.url}: ${JSON.stringify(files[i])}`);
          }

          if (mimeType && typeof mimeType !== "string") {
            throw Error(`invalid mimetype for ${transferAsset.target.url}: ${JSON.stringify(files[i])}`);
          }

          if (typeof uploadToken !== "string") {
            throw Error(`invalid uploadToken for ${transferAsset.target.url}: ${JSON.stringify(files[i])}`);
          } // if the client has no mimetype specified, use the mimetype provided by AEM
          // if AEM cannot detect a mimetype default to application/octet-stream


          if (!transferAsset.metadata.contentType) {
            let contentType = mimeType;

            if (!contentType) {
              contentType = MIMETYPE.APPLICATION_OCTET_STREAM;
            }

            transferAsset.metadata = new AssetMetadata(transferAsset.metadata.filename, contentType, transferAsset.metadata.contentLength);
          }

          transferAsset.multipartTarget = new AssetMultipart(uploadURIs, minPartSize, maxPartSize, transferAsset.target.multipartHeaders, completeUrl, uploadToken);
        }

        for (const transferAsset of assets) {
          controller.notify(TransferEvents.AFTER_AEM_INITIATE_UPLOAD, _this.name, transferAsset);
          yield transferAsset;
        }
      } catch (error) {
        for (const transferAsset of assets) {
          controller.notifyError(_this.name, error, transferAsset);
        }
      }
    })();
  }

}

module.exports = {
  AEMInitiateUpload
};